import React from 'react'
import {Dictionary} from 'lodash'

import {GetCategories_categories_edges_node} from './_gql-types/GetCategories'

type ToggleCategoryFn = (event: React.ChangeEvent<HTMLInputElement>) => void


interface CategoryFilterItemProps {
  category: GetCategories_categories_edges_node
  selected: Dictionary<boolean>
  toggle: ToggleCategoryFn
}


export default function CategoryFilterItem({category, selected, toggle}: CategoryFilterItemProps) {
  const formId = `form-${category.id}`

  const children = category?.children?.edges.filter(({node}) => node.products?.totalCount)

  const isSelected = selected[category.slug] || false

  return (
    <div className="form-check py-1 mb-0">
      <input
        className="form-check-input"
        type="checkbox"
        id={formId}
        checked={isSelected}
        onChange={toggle}
        value={category.slug}
      />

      <label
        className="form-check-label"
        role="button"
        htmlFor={formId}
      >
        {category.name} ({category.products?.totalCount})
      </label>

      {isSelected && (
        <div className="pl-3">
          {children?.map(({node}) => (
            <CategoryFilterItem
              key={node.id}
              category={node as GetCategories_categories_edges_node}
              selected={selected}
              toggle={toggle}
            />
          ))}
        </div>
      )}
    </div>
  )
}
